export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const RECAPTCHA_KEY_V2 = process.env.REACT_APP_RECAPTCHA_SITE_KEY_V2;
export const INTERCOM_KEY = process.env.REACT_APP_INTERCOM_KEY;
export const GTM_KEY = process.env.REACT_APP_GTM_KEY;
export const UNSPLASH_ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;